import e from "@dialpad/dialtone-tokens/layered/themes/tokens-marigold-colors.css?inline";
//#region themes/marigold.js
var t = {
	brand: {
		css: e,
		name: "marigold"
	},
	material: { name: "sandstone" }
};
//#endregion
export { t as default };
